import { HelpPageContent } from 'components/help_sidebar';
import { FormattedMessage } from 'react-intl';

const strong = (chunks: React.ReactNode) => (
    <strong>
        {chunks}
    </strong>
);

export const helpContent: HelpPageContent = {
    segments: [
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Use the search bar to find users by <strong>name</strong>, <strong>email</strong>, or <strong>role</strong>. Apply filters to narrow results to specific user types." id="use_the_search_bar_to_find_users_by_name.43638d03" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Searching Administrators" id="searching_administrators.9a294ba3" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Click <strong>Create User</strong> to add a new administrator or staff account. Assign a role and configure initial permissions." id="click_create_user_to_add_a_new_administr.f685c02d" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Creating a System Administrator" id="creating_a_system_administrator.a9c743e2" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="Select a user to view their profile. Use the tabs to manage <strong>personal details</strong>, reset their <strong>password</strong>, adjust <strong>permissions</strong>, update <strong>preferences</strong>, or configure <strong>early access</strong> settings." id="select_a_user_to_view_their_profile_use.cbee990c" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="System Administrator Profile" id="system_administrator_profile.06d5d5d1" />
        },
        {
            body: (
                <p>
                    <FormattedMessage defaultMessage="The <strong>Permissions</strong> tab controls what actions a user can perform. Assign roles carefully — changes take effect immediately." id="the_permissions_tab_controls_what_action.6439f7be" values={{ strong }} />
                </p>
            ),
            title: <FormattedMessage defaultMessage="Permissions" id="permissions.076a2862" />
        }
    ],
    title: <FormattedMessage defaultMessage="Administrators" id="administrators.0708295c" />
};
